import { NgModule } from '@angular/core';
import { LoadingComponent } from './loading.component';
import { LottieIconModule } from '@app/components/atoms/lottie-icon/lottie-icon.module';
import { ContainerModule } from '@app/components/atoms/container/container.module';

@NgModule({
  declarations: [LoadingComponent],
  exports: [LoadingComponent],
  imports: [LottieIconModule, ContainerModule],
})
export class LoadingModule {}
